module.exports = __webpack_public_path__ + "img/saving.a2fb2a12.svg";